<template>
  <div class="animated revealUp">
      
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">{{ $t('add') }} {{ $tc('module', 2) }}</div>
      <router-link class="btn-blue" to="modules">{{ $tc('module', 2) }} {{ $tc('list', 2) }}</router-link>
    </div>
    <div class="white-wrapper">
      <form>
        <div class="row">
          <div
            v-for="(item, index) in Modules"
            :key="index"
            v-if="item.fieldname !== 'module_id'"
            class="col-lg-6 col-xl-4 align-self-center mb-4"
          >
            <div v-if="item.fieldname !== 'module_is_active'">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    @focus="onFocusHandler"
                    :type="item.type"
                    :name="item.fieldname"
                    :id="item.fieldname"
                    v-validate="item.validation"
                    v-model="item.fieldvalue"
                  />
                  <label>{{ $tc(item.label, 1)}}</label>
                </div>
              </div>
              <p
                v-if="submitted && errors.has(item.fieldname)"
                class="error_message"
              >{{ errors.first(`${item.fieldname}`) }}</p>
            </div>
            <div v-if="item.fieldname === 'module_is_active'" class="d-flex align-items-center">
              <label class="mb-0 mr-3">{{ $t('active') }}</label>
              <label class="ios-switch">
                <input type="checkbox" class="ios-checkbox" v-model="item.fieldvalue" />
                <span class="switch-slider"></span>
              </label>
            </div>
          </div>

          <div class="col-md-12 text-center mt-4">
            <button class="btn-blue" @click.prevent.stop="handleSubmit(true)">{{ $t('save') }}</button>
            <button
              @click.prevent.stop="handleSubmit(false)"
              type="submit"
              class="btn-blue"
            >{{ $t('saveaddmore') }}</button>
            <button @click.prevent.stop="resetHandler()" class="btn-black">{{ $t('reset') }}</button>
            <b-button class="btn-outline-grey" variant="default" to="modules">{{ $t('cancel') }}</b-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import Modules from "@/helper/formJSONMaster/Modules";

export default {
  data() {
    return {
      Modules: Modules.ms_modules,
      // v-validate="'required|email'"
      submitted: false,
      Methods: Modules.Methods
    };
  },
  mounted() {
    console.log("Modules :", Modules);
    this.resetHandler();
  },
  methods: {
    onFocusHandler: function() {
      // this.submitted = false;
    },
    resetHandler: function() {
      this.Modules.map(x => {
        if (x.type === "text" || x.type === "date") {
          x.fieldvalue = "";
        } else if (x.type === "radio") {
          x.fieldvalue = true;
        }
      });
    },
    handleSubmit(flag) {
      console.log("call submit :");
      this.submitted = true;
      this.$validator.validate().then(valid => {
        console.log("valid :", valid);
        if (valid) {
          console.log("valid :", valid);
          let body = this.getRequestBody("POST", this.Modules, this.Methods);
          console.log("body :", body);

          MasterService.GlobalRequest(body)
            .then(response => {
              const { data } = response;
              if (data.status) {
                console.log("here :", data);
                if (flag) {
                  this.$router.push({
                    path: "/master/modules"
                  });
                } else {
                  this.resetHandler();
                }
              } else {
                console.log("show error1 :", data.message);
              }
            })
            .catch(error => {
              console.log("show error2 :", error);
            });
        } else {
          console.log("else :");
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/ModulesComponents/addModule.vue